module.exports = __webpack_public_path__ + "img/58_12.aecc984f.png";